<template>
<transition name="dialog-transition">

    <div
        class="lni-c-modal__overlay"
        :id="controlId"
        v-show="visible"
        @click.stop.self="allowClose ? closeModal() : null"
        @keydown.escape="allowClose ? closeModal() : null"
        >

        <div
            class="lni-c-modal lni-u-pa2"
            aria-live="assertive"
            :tabindex="!allowClose ? '0' : null"
            :aria-labelledby="controlId + '_label'"
            :class="!allowClose ? 'lni-u-pt4' : null"
            :role="allowClose ? 'dialog' : 'alert'"
            :aria-busy="!allowClose"
            @keydown.tab="handleTab"
            @keydown.tab.shift="handleShiftTab">

            <div class="lni-c-modal__content lni-u-pv2">
                <h1
                    class="lni-c-modal__heading"
                    :id="controlId + '_label'">{{text}}</h1>
                <div class="lni-u-flex lni-u-justify-end">
                    <button
                        class="lni-c-button lni-u-mr2"
                        @click="handleClick('OK')">Ok</button>
                    <button
                        class="lni-c-button"
                        @click="handleClick('CANCEL')">Cancel</button>
                </div>
            </div>
            <button
                v-if="allowClose"
                class="lni-c-modal__close-button lni-c-button lni-u-pa1"
                @click="closeModal">
                <span class="lnicon--close lni-c-modal__close-button-icon" aria-hidden="true"></span>
                <span class="lni-u-visually-hidden">Close</span>
            </button>
        </div>
    </div>
</transition>
</template>


<script>
import framework from '../../framework';
/**
*  The x-modal component.
*  @module components/x-dialog
*/

/**
* The x-dialog
*/

export default {
    name: 'x-dialog',
    mixins: [
        framework.mixins.abstractElement,
    ],
    data() {
        return {
            lastFocusedElement: null,
            tabbableElements: null,
            visible: false,
            promiseResolver: null,
        };
    },
    mounted() {
        if (this.allowClose) {
            /* Save all the tabble elements within modal */
            this.tabbableElements = this.getTabbableElements(this.$el);
            this.firstTabStop = this.tabbableElements[0];
            this.lastTabStop = this.tabbableElements[
                this.tabbableElements.length - 1
            ];
        } else {
            /* There is nothing to interact with */
            this.firstTabStop = this.$el.children[0];
            this.lastTabStop = this.firstTabStop;
        }

        /* Put focus on first tabbable */
        this.firstTabStop.focus();
    },
    methods: {
        setVisibility(visible) {
            this.visible = visible;
        },
        handleClick(actionType) {
            this.$nextTick(() => {
                this.lastFocusedElement.focus();
            });
            this.setVisibility(false);

            this.promiseResolver(actionType);
        },
        confirm() {
            /* Save last element in focus */
            this.lastFocusedElement = document.activeElement;
            this.setVisibility(true);

            this.$nextTick(() => {
                this.tabbableElements[0].focus();
            });
            return new Promise((resolve) => {
                this.promiseResolver = resolve;
            });
        },
        closeModal() {

            this.lastFocusedElement.focus();
            this.setVisibility(false);
            this.promiseResolver('CANCEL');

        },
        getTabbableElements(container) {
            //TODO: don't select hidden elements as well (this does).
            const candidateSelectors = [
                'input',
                'select',
                'a[href]',
                'textarea',
                'button',
                '[tabindex]:not([tabindex*="-"])',
            ];
            const tabbableNodeList = container.querySelectorAll(
                candidateSelectors,
            );
            /* Convert to regular array */
            return Array.prototype.slice.call(tabbableNodeList);
        },
        handleTab(event) {
            if (document.activeElement === this.lastTabStop) {
                event.preventDefault();
                this.firstTabStop.focus();
            }
        },
        handleShiftTab(event) {
            if (document.activeElement === this.firstTabStop) {
                event.preventDefault();
                this.lastTabStop.focus();
            }
        },
    },
    computed: {
        /**
         * The dialog text.
         * @returns {string} dialog text.
         */
        text() {
            return this.getAttribute('text', '');
        },
        /**
         * The text for the label.
         * @returns {string} label text.
         */
        allowClose() {
            let allow = this.getAttribute('allowClose', 'false');
            return allow === 'true';
        },
    },
};
</script>

<style lang="scss">
@import '../../styles/settings.scss', 'dialog.scss';
</style>



// WEBPACK FOOTER //
// source/components/x-dialog/x-dialog.vue